<template lang="html">
  <div ref="editor" class="editor"></div>
</template>

<script>
import { markRaw } from 'vue'
import * as monaco from 'monaco-editor';
import hints from '@/assets/ref/monaco.hints.js'

export default {
  props: {
    modelValue: {
      type: String,
      default: null
    },
    language: {
      type: String,
      default: null
    },
    disabledminimap: {
      type: Boolean
    }
  },
  emits: ['update:modelValue'],
  data() {
    return {
      monacoEditor: null
    };
  },
	methods: {
		changeFileData(value) {
			this.fileData.data = value;
		},
		runOnce() {
			if (window.MONACO_ONCE_LOADED) return;
			this.loadCustomTheme();
			this.loadSnippetsHint();
			window.MONACO_ONCE_LOADED = true;
		},
		loadCustomTheme() {
			monaco.editor.defineTheme('custom-theme', {
				base: 'vs-dark',
				inherit: true,
				rules: [{ background: '1f282d' }],
				colors: {
					'editor.background': '#1f282d'
				}
			});
		},
		loadSnippetsHint() {
			hints.forEach(item => {
				const suggestions = item.hints.map(hint => {
					return {
						label: hint.displayText,
						kind: monaco.languages.CompletionItemKind.Snippet,
						insertText: hint.text,
						insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
						documentation: hint.displayText
					};
				});
				item.languages.forEach(language => {
					monaco.languages.registerCompletionItemProvider(language, {
						provideCompletionItems: () => {
							return { suggestions };
						}
					});
				});
			});
		}
	},
  watch: {
    modelValue() {
      if (this.modelValue !== this.monacoEditor.getValue()) {
        this.monacoEditor.setValue(this.modelValue);
      }
    },
    language() {
      monaco.editor.setModelLanguage(this.monacoEditor.getModel(), this.language);
    },
    disabledminimap() {
      this.monacoEditor.updateOptions({
        minimap: {
          enabled: !this.disabledminimap
        }
      });
    }
  },
	mounted() {
		this.runOnce();
		const monacoEditor = monaco.editor.create(this.$refs.editor, {
			value: this.modelValue,
			language: this.language,
			theme: "custom-theme",
			automaticLayout: true
		});
    this.monacoEditor = markRaw(monacoEditor);
    if (this.disabledminimap) {
      monacoEditor.updateOptions({
        minimap: {
          enabled: false
        }
      });
    }
		monacoEditor.getModel().updateOptions({insertSpaces: false});
		monacoEditor.onDidChangeModelContent(() => {
			this.$emit('update:modelValue', monacoEditor.getValue());
		});
	},
	beforeUnmount() {
		this.monacoEditor.getModel().dispose();
	}
}
</script>

<style lang="css" scoped>
.editor {
  overflow: hidden;
}
</style>
